import { Popper as MuiPopper } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const Popper = styled(MuiPopper)`
  width: 280px;
  flex-shrink: 0;
  border-radius: ${theme.attributes.borderRadius.tertiary};
  background: ${theme.colors.devicesPopupBg};
  box-shadow: 0 4px 8px 0 rgba(30, 26, 29, 0.5);
  z-index: 1000000000;
  margin-right: ${theme.spacing.xSmall}px !important;
  max-height: 368px;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 4px;
    background: transparent;
  }

  ::-webkit-scrollbar-track {
    box-shadow: none;
    background: transparent;
    margin-top: 15px;
    margin-bottom: 15px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #292128;
    border-radius: ${theme.attributes.borderRadius.quaternary};
  }

  .button-wrapper {
    position: sticky;
    padding: 2px 0 ${theme.spacing.small}px ${theme.spacing.medium}px;
    bottom: 0;
    left: 0;
    background: ${theme.colors.devicesPopupBg};
  }

  .content {
    padding: ${theme.spacing.md}px 0;

    .list {
      display: flex;
      flex-flow: column wrap;

      .list-item {
        width: 100%;
        height: 38px;
        gap: ${theme.spacing.md}px;

        .MuiFormControlLabel-root {
          display: flex;
          align-items: center;
          padding: ${theme.spacing.xSmall}px ${theme.spacing.medium}px;
          margin: 0;

          .MuiCheckbox-root {
            padding: 0 ${theme.spacing.xSmall}px 0 0;
          }

          .MuiTypography-root {
            color: ${theme.colors.controlBorder};
            font-family: ${theme.typography.fontFamily.primary};
            font-size: ${theme.typography.fontSize.large};
            font-style: normal;
            font-weight: ${theme.typography.fontWeight.bold};
            line-height: 22px;
          }

          &.is-checked .MuiTypography-root {
            color: ${theme.colors.foreground};
          }
        }
      }
    }
  }
`
